export default class ApiResponse{
    status;
    data;
    Message;

    constructor(statusCode = null, data = null, message = null){
        this.status = statusCode;
        this.data = data;
        this.Message = message;
    }   
}